import { LoaderSpin } from '@framework/ui/components/loader/LoaderSpin.tsx';
import { DividerTitleElement } from '@framework/ui/components/text/DividerTitleElement.tsx';
import { getNetworkErrorMessage } from '@framework/ui/core/errors/getNetworkErrorMessage.tsx';

import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import { type CreateCommunicationRequest } from '../../../schema/communication/CreateCommunicationRequestSchema.ts';
import { CommunicationAttachmentFields } from './CommunicationAttachmentFields.tsx';
import { CommunicationForwardFields } from './CommunicationForwardFields.tsx';
import { CommunicationTypeFields } from './CommunicationTypeFields.tsx';
import { useSelectedCommunicationType } from './hooks/useSelectedCommunicationType.tsx';
import { useHydrateCommunication } from './hydrate/useHydrateCommunication.ts';

interface ICommunicationDetailFormProps {
  communication: CreateCommunicationRequest | null | undefined;
  isManual: boolean | undefined;
  hasForwarded: boolean | null | undefined;
}

/**
 * Form per la configurazione di una comminicazione in base al tipo di comunicazione
 * scelto. Gestisce l'idratazione (anteprima)
 */
export function CommunicationDetailForm(props: ICommunicationDetailFormProps) {
  const { communication, isManual, hasForwarded } = props;
  const { t } = useTranslation();

  const selectedType = useSelectedCommunicationType();

  // Idratazione della comunicazione (anteprima)
  const { isLoading, error } = useHydrateCommunication({
    selectedTypeId: selectedType?.id,
    disabled: isManual,
  });

  if (isLoading) {
    return <LoaderSpin transparent />;
  }

  if (error) {
    return (
      <Alert
        message={t('error', 'Errore')}
        description={getNetworkErrorMessage(
          error,
          t(
            'communications.hydrate-error',
            "Si è verificato un errore durante il recupero dell'anteprima della comunicazione. Riprovare.",
          ),
        )}
        type="error"
      />
    );
  }

  if (!selectedType?.id) return null;

  return (
    <>
      <DividerTitleElement
        title={t('communications.communication-title', 'Comunicazione')}
        removeTopMargin
      />
      <CommunicationTypeFields
        communicationType={selectedType}
        isManual={isManual}
        communication={communication}
      />

      {/* //TODO Inoltro Comunicazione */}
      {hasForwarded && <CommunicationForwardFields />}

      <CommunicationAttachmentFields
        communication={communication}
        communicationType={selectedType}
      />
    </>
  );
}
